var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import logger from '../util/logger';
import BaseCall from './BaseCall';
import { getDisplayMedia, setMediaElementSinkId } from '../util/webrtc';
export default class Call extends BaseCall {
  constructor() {
    super(...arguments);
    this._statsInterval = null;
  }

  hangup() {
    let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let execute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (this.screenShare instanceof Call) {
      this.screenShare.hangup(params, execute);
    }

    super.hangup(params, execute);
  }

  startScreenShare(opts) {
    return __awaiter(this, void 0, void 0, function* () {
      const displayStream = yield getDisplayMedia({
        video: true
      });
      displayStream.getTracks().forEach(t => {
        t.addEventListener('ended', () => {
          if (this.screenShare) {
            this.screenShare.hangup();
          }
        });
      });
      const {
        remoteCallerName,
        remoteCallerNumber,
        callerName,
        callerNumber
      } = this.options;
      const options = Object.assign({
        screenShare: true,
        localStream: displayStream,
        destinationNumber: "".concat(this.extension, "-screen"),
        remoteCallerName,
        remoteCallerNumber: "".concat(remoteCallerNumber, "-screen"),
        callerName: "".concat(callerName, " (Screen)"),
        callerNumber: "".concat(callerNumber, " (Screen)")
      }, opts);
      this.screenShare = new Call(this.session, options);
      this.screenShare.invite();
      return this.screenShare;
    });
  }

  stopScreenShare() {
    if (this.screenShare instanceof Call) {
      this.screenShare.hangup();
    }
  }

  setAudioOutDevice(deviceId) {
    return __awaiter(this, void 0, void 0, function* () {
      this.options.speakerId = deviceId;
      const {
        remoteElement,
        speakerId
      } = this.options;

      if (remoteElement && speakerId) {
        return setMediaElementSinkId(remoteElement, speakerId);
      }

      return false;
    });
  }

  _finalize() {
    this._stats(false);

    super._finalize();
  }

  _stats() {
    let what = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    if (what === false) {
      return clearInterval(this._statsInterval);
    }

    logger.setLevel(2);
    this._statsInterval = window.setInterval(() => __awaiter(this, void 0, void 0, function* () {
      const stats = yield this.peer.instance.getStats(null);
      let statsOutput = '';
      const invalidReport = ['certificate', 'codec', 'peer-connection', 'stream', 'local-candidate', 'remote-candidate'];
      const invalidStat = ['id', 'type', 'timestamp'];
      stats.forEach(report => {
        if (invalidReport.includes(report.type)) {
          return;
        }

        statsOutput += "\n".concat(report.type, "\n");
        Object.keys(report).forEach(statName => {
          if (!invalidStat.includes(statName)) {
            statsOutput += "\t".concat(statName, ": ").concat(report[statName], "\n");
          }
        });
      });
      logger.info(statsOutput);
    }), 2000);
  }

}